import { RunDeleteConfirmDialog } from "features/Runs/components/ModalsAndDialogs/DeleteConfirmDialog";
import { RunsModalContainer } from "features/Runs/components/ModalsAndDialogs/ModelContainer";
import { RunsModalContent } from "features/Runs/components/ModalsAndDialogs/RunsModalContent";
import { RunActivityDialog } from "features/Runs/components/ModalsAndDialogs/TaskSummaryDialog";
import { useRunsModalState } from "features/Runs/state/hooks";
import { RunsModalActions } from "features/Runs/state/modal/actions";
import React from "react";

export function RunsModalsAndDialogs(): JSX.Element {
  const { runsModalDispatch } = useRunsModalState();

  const handleClose = () => {
    runsModalDispatch({ type: RunsModalActions.CLOSE_MODAL });
  };
  return (
    <>
      <RunDeleteConfirmDialog />
      <RunActivityDialog />
      <RunsModalContainer>
        <RunsModalContent handleClose={handleClose} />
      </RunsModalContainer>
    </>
  );
}
